export const PORT = 8080;
export const BASE_URL = `http://localhost:${PORT}`;
export const DEPLOYED_BASE_URL = `https://hrtoolbackend-gjbjdgazeadydqa9.centralindia-01.azurewebsites.net`;
export const DEPLOYED_BASE_URL_GEN_AI = `https://hrtoolgenai-bdf5dga3d8g4dufw.centralindia-01.azurewebsites.net`;
export const DEPLOYED_BASE_URL_GEN_AI_Question = `https://genai-hirefox-d2fma6e5debjahgq.centralindia-01.azurewebsites.net`;
